// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_angular_animations_fesm2022_browser_mjs":"36b938a4151ff7ae","node_modules_apexcharts_dist_apexcharts_esm_js":"d7a7600a745ce2f7"}[chunkId] + ".js";
};